import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export default function setIconsVertical() {
  const sections = document.querySelectorAll('[data-icons-vertical]');

  sections.forEach((section) => {
    const carousel = section.querySelector('.swiper');
    if (!carousel) return;

    const pagination = section.querySelector('.swiper-pagination');

    new Swiper(carousel, {
      modules: [Pagination],
      slidesPerView: 2,
      spaceBetween: 0,
      watchOverflow: true,
      centerInsufficientSlides: true,
      preloadImages: false,
      speed: 600,
      ...(pagination && {
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
      }),
      breakpoints: {
        992: {
          slidesPerView: 4,
        },
      },
    });
  });
}
